import React from 'react';
import PropTypes from 'prop-types';
import { Formik, Form } from 'formik';

import { makeListingFullAddressString } from 'common/listingHelpers';

import { createInitialValues, createFormValidationFn } from 'client/helpers/formikHelpers';

import SrBox from 'client/components/SrBox';
import SrText from 'client/components/SrText';
import SrFlex from 'client/components/SrFlex';
import SrButton, {
  SR_BUTTON_THEME_ADOBE_GREY,
  SR_BUTTON_THEME_ADOBE_BLUE,
} from 'client/components/SrButton/SrButton';
import SrFormikField, { SR_FIELD_THEME_ADOBE } from 'client/components/SrFormikField';
import SrModalV2 from 'client/components/SrModalV2/SrModalV2';
import SrGridRow from 'client/components/SrGridRow/SrGridRow';

const SrHouseholdNoteShareModal = ({
  listingsApplyingFor,
  shareHouseholdNote,
  onClose,
  onSubmit,
}) => {
  const formField = {
    id: 'listingIds',
    type: 'multiple_choice',
    properties: {
      multipleSelection: true,
      useArrayValues: true,
      toggleSingleSelection: true,
      choices: (listingsApplyingFor || []).map((listing) => {
        return {
          label: makeListingFullAddressString(listing),
          value: listing.id,
        };
      }),
    },
    validations: ['required'],
  };

  return (
    <SrModalV2 showCloseButton={false} contentMaxWidth="555px">
      <Formik
        onSubmit={onSubmit}
        initialValues={createInitialValues({
          formFields: [formField],
          defaultValues: {
            listingIds: (shareHouseholdNote.householdSharedListingNotes || []).map(
              ({ listingId }) => listingId,
            ),
          },
        })}
        validate={createFormValidationFn([formField])}
        render={(formikBag) => (
          <SrBox bgColor="white" borderRadius="24px" padding="28px 25px 30px">
            <Form>
              <SrBox>
                <SrText font="greycliff" weight="800" size="28" lineHeight="34px">
                  Select Listing to Share Note
                </SrText>
              </SrBox>
              <SrGridRow autofit autofitMinColumnWidth="300px">
                <SrFormikField
                  formikBag={formikBag}
                  formField={formField}
                  theme={SR_FIELD_THEME_ADOBE}
                />
              </SrGridRow>
              <SrFlex marginTop="35px" align="center" justify="center">
                <SrText
                  font="greycliff"
                  weight="600"
                  fontSize="16px"
                  lineHeight="22px"
                  color="blueGreycliff"
                >
                  Any links in the note will be hidden from the partner.
                </SrText>
              </SrFlex>
              <SrFlex marginTop="20px" gap="33px" justify="between">
                <SrBox width="100%">
                  <SrButton onClick={onClose} theme={SR_BUTTON_THEME_ADOBE_GREY}>
                    {shareHouseholdNote?.householdSharedListingNotes?.length === 0
                      ? "Don't Share"
                      : 'Cancel'}
                  </SrButton>
                </SrBox>
                <SrBox width="100%">
                  <SrButton type="submit" theme={SR_BUTTON_THEME_ADOBE_BLUE}>
                    {shareHouseholdNote?.householdSharedListingNotes?.length === 0
                      ? 'Share Note'
                      : 'Update'}
                  </SrButton>
                </SrBox>
              </SrFlex>
            </Form>
          </SrBox>
        )}
      />
    </SrModalV2>
  );
};

SrHouseholdNoteShareModal.propTypes = {
  listingsApplyingFor: PropTypes.array.isRequired,
  shareHouseholdNote: PropTypes.object.isRequired,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

SrHouseholdNoteShareModal.displayName = 'SrHouseholdNoteShareModal';
export default SrHouseholdNoteShareModal;
